import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Ticket, TicketPrioritaet } from '../../../../projects/kiene-core/src/lib/classes/ticket';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-prioritaeten-dialog',
    templateUrl: './prioritaeten-dialog.component.html',
    styleUrls: ['./prioritaeten-dialog.component.scss'],
})
export class PrioritaetenDialogComponent implements OnInit {
    prioritaeten: TicketPrioritaet[] = [];
    selectPriorityCtrl = new FormControl();
    isSaving = false;

    constructor(
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        public dialogRef: MatDialogRef<PrioritaetenDialogComponent>,
        public dialog: MatDialog,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        @Inject(MAT_DIALOG_DATA) public data: Ticket,
    ) {}

    ngOnInit(): void {
        this.api.get(this.apiBaseUrl + 'ticket_prioritaet/read.php').subscribe({
            next: result => {
                this.prioritaeten = result.records;
                const currentPrioritaet = this.prioritaeten.find(
                    prioritaet => prioritaet.wert == this.data.prioritaet,
                );
                this.selectPriorityCtrl.setValue(currentPrioritaet);
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden der Prioritäten', error);
            },
        });
    }

    public closeDialog(): void {
        this.isSaving = true;
        this.data.prioritaet = this.selectPriorityCtrl.value.wert;
        this.api.post(this.apiBaseUrl + 'ticket/update.php', this.data).subscribe({
            next: () => {
                this.messageService.infoMessage('Priorität gespeichert');
                this.dialogRef.close(true);
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Speichern der Priorität', error);
                this.isSaving = false;
            },
        });
    }
}
